import React from "react";
import { motion } from "framer-motion";
import { FaTwitter, FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { ArrowRight, BarChart2, ShoppingBag, Truck, Users } from "lucide-react";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const features = [
    {
      icon: ShoppingBag,
      title: "Order Processing",
      description:
        "Efficiently manage and process orders from multiple channels.",
    },
    {
      icon: Truck,
      title: "Shipping Integration",
      description:
        "Seamlessly integrate with major shipping carriers for easy fulfillment.",
    },
    {
      icon: BarChart2,
      title: "Inventory Tracking",
      description: "Real-time inventory management across all your warehouses.",
    },
    {
      icon: Users,
      title: "Customer Management",
      description: "Build stronger relationships with integrated CRM features.",
    },
  ];

  return (
    <div className="bg-gradient-to-br from-blue-600 via-indigo-700 to-purple-800 text-white min-h-screen">
      <div className="container mx-auto px-4 py-16 sm:py-24 lg:py-32 min-h-[100vh]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-6">
              Streamline Your{" "}
              <span className="text-yellow-400">Order Management</span>
            </h1>
            <p className="text-xl sm:text-2xl mb-8 text-blue-100">
              Effortlessly manage orders, track inventory, and boost your
              business efficiency with our all-in-one platform.
            </p>
            <motion.div
              className="flex flex-col sm:flex-row gap-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              <Link
                to="/login"
                className="bg-yellow-400 text-blue-900 px-6 py-3 rounded-lg text-lg font-medium flex items-center justify-center hover:bg-yellow-300 transition-colors duration-300"
              >
                Get Started
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </motion.div>
          </motion.div>

          <motion.div
            className="grid grid-cols-2 gap-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            {features.map((feature, index) => (
              <motion.div
                key={feature.title}
                className="bg-white/10 backdrop-blur-lg rounded-xl p-6 shadow-lg"
                whileHover={{
                  scale: 1.05,
                  backgroundColor: "rgba(255, 255, 255, 0.15)",
                }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  type: "spring",
                  stiffness: 300,
                  delay: 0.2 * index,
                  duration: 0.5
                }}
              >
                <feature.icon className="h-10 w-10 mb-4 text-yellow-400" />
                <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="text-blue-100">{feature.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>

      <motion.footer
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1 }}
        className="bg-gray-800 text-white text-center p-2 mt-4 shrink-0 w-full rounded-md"
      >
        <div className="container mx-auto px-4">
          {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
            <div>
              <h3 className="text-xl font-semibold mb-4">About Us</h3>
              <p className="text-gray-400">
                We"re dedicated to simplifying order management and boosting efficiency for businesses of all sizes.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Services</h3>
              <ul className="space-y-2">
                {[
                  "Order Management",
                  "Inventory Tracking",
                  "Shipping Integration",
                  "Customer Management",
                ].map((service) => (
                  <li key={service}>
                    <Link
                      to={`/${service.toLowerCase().replace(" ", "-")}`}
                      className="text-gray-400 hover:text-yellow-400 transition-colors duration-300"
                    >
                      {service}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Contact</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="mailto:support@example.com"
                    className="text-gray-400 hover:text-yellow-400 transition-colors duration-300"
                  >
                    support@example.com
                  </a>
                </li>
                <li>
                  <a
                    href="tel:+1234567890"
                    className="text-gray-400 hover:text-yellow-400 transition-colors duration-300"
                  >
                    +123 456 7890
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Follow Us</h3>
              <div className="flex space-x-4">
                {[
                  { Icon: FaTwitter, href: "https://twitter.com" },
                  { Icon: FaFacebook, href: "https://facebook.com" },
                  { Icon: FaInstagram, href: "https://instagram.com" },
                  { Icon: FaLinkedin, href: "https://linkedin.com" },
                ].map(({ Icon, href }) => (
                  <motion.a
                    key={href}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-yellow-400 transition-colors duration-300"
                    whileHover={{ scale: 1.1 }}
                    transition={{ type: "spring", stiffness: 300 }}
                  >
                    <Icon className="h-6 w-6" />
                  </motion.a>
                ))}
              </div>
            </div>
          </div> */}

          {/* Responsive Footer */}
          <p className="text-sm">
            Designed with ❤️ and crafted with care by Team{" "}
            <a
              href="https://www.youtube.com/@SHALENDERSINGH"
              target="_blank"
              rel="noopener noreferrer"
              className="text-yellow-500 font-bold block sm:inline hover:text-yellow-600"
            >
              SMART ITBOX
            </a>
          </p>
        </div>
      </motion.footer>
    </div>
  );
}
